/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { MdPlayArrow, MdSync } from 'react-icons/md';
import ReactJson from 'react-json-view';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import PropTypes from 'prop-types';

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
} from '@material-ui/core';

import CustomDialogTitle from '~/components/CustomDialogTitle';
import LocaleMessage from '~/components/LocaleMessage';
import Splash from '~/components/Splash/Inside';

import api from '~/services/pluginbot-api';

import { ParameterArea, JSONArea } from '../styles';

const DEFAULT_BODIES = {
    dynamic_answers: {
        session_id: 123,
        message: '',
        context: {},
        parameters: {},
    },
};

export default function PluginconfigTest({
    handleFormClose,
    pluginType,
    pluginConfig,
}) {
    const p_type = pluginType.slug;

    const user_settings = useSelector(state => state.settings || null);
    const loc = user_settings.locale;
    const lang = loc && loc.code ? loc.code : 'pt_BR';
    // const lng_all = lng_labels[lang];

    const [isLoading, setIsLoading] = useState(false);
    const [testBody, setTestBody] = useState({
        language: lang,
    });
    const [responseBody, setResponseBody] = useState(null);

    // function requestError(error) {
    //     if (error.response) {
    //         const message = (
    //             <LocaleMessage msg={`errors.${error.response.data.code}`} />
    //         );
    //         const { status } = error.response;
    //         toast.error(message);
    //     } else if (error.request) {
    //         toast.error(<LocaleMessage msg="errors.request" />);
    //     } else {
    //         toast.error(<LocaleMessage msg="errors.unknown" />);
    //     }
    //     setIsLoading(false);
    // }

    async function submitTestIntegration() {
        setIsLoading(true);
        const start = Date.now();
        await api
            .post(`pluginconfigs/${pluginConfig.id}/test`, testBody)
            .then(response => {
                toast.success(
                    // <LocaleMessage msg="page.plugins.form.config_added" />
                    'Pluginconfig Test'
                );
                const { status, data } = response;
                const finish = Date.now();

                const time = finish - start;
                setResponseBody({
                    status,
                    time,
                    data,
                });
            })
            .catch(() => {});
        setIsLoading(false);
    }

    function resetBody() {
        const p_def_body = DEFAULT_BODIES[p_type] || {};
        setResponseBody(null);
        setTestBody({
            ...p_def_body,
        });
    }

    useEffect(() => {
        resetBody();
    }, [p_type]);

    function renderDynamicAnswerTest() {
        return (
            <div className="col-12 row">
                <ParameterArea className="col-md-6 col-12 mb-3">
                    <div className="col-12 mb-3" style={{ padding: '0px' }}>
                        <ReactJson
                            src={testBody || {}}
                            name={false}
                            enableClipboard={false}
                            displayObjectSize={false}
                            displayDataTypes={false}
                            onAdd={edit => setTestBody(edit.updated_src)}
                            onEdit={edit => setTestBody(edit.updated_src)}
                            onDelete={edit => setTestBody(edit.updated_src)}
                        />
                    </div>
                    <div className="col-12 mb-3" style={{ padding: '0px' }}>
                        <Button
                            fullWidth
                            onClick={() => submitTestIntegration()}
                            variant="contained"
                            color="primary"
                            startIcon={<MdPlayArrow />}
                            style={{
                                whiteSpace: 'nowrap',
                                padding: '5px 20px',
                            }}
                        >
                            {/* <LocaleMessage msg="page.plugins.form.add_config" /> */}
                            TEST INTEGRATION
                        </Button>
                    </div>
                    <div className="col-12" style={{ padding: '0px' }}>
                        <Button
                            fullWidth
                            onClick={() => resetBody()}
                            variant="outlined"
                            color="primary"
                            startIcon={<MdSync />}
                            style={{
                                whiteSpace: 'nowrap',
                                padding: '5px 20px',
                            }}
                        >
                            {/* <LocaleMessage msg="page.plugins.form.add_config" /> */}
                            RESET BODY
                        </Button>
                    </div>
                </ParameterArea>

                <ParameterArea className="col-md-6 col-12 mb-3">
                    {isLoading ? (
                        <Splash />
                    ) : (
                        <>
                            {responseBody ? (
                                <>
                                    <div
                                        className="col-12 mb-3"
                                        style={{ padding: '0px' }}
                                    >
                                        <p>STATUS: {responseBody.status}</p>
                                        <p>
                                            RESPONSE TIME: {responseBody.time}{' '}
                                            ms
                                        </p>
                                        <p>RESPONSE BODY:</p>
                                        <JSONArea className="mt-3">
                                            <ReactJson
                                                src={
                                                    responseBody &&
                                                    responseBody.data
                                                        ? responseBody.data
                                                        : {}
                                                }
                                                name={false}
                                                enableClipboard={false}
                                                displayObjectSize={false}
                                                displayDataTypes={false}
                                                style={{
                                                    wordBreak: `break-word !important`,
                                                }}
                                            />
                                        </JSONArea>
                                    </div>
                                    <div
                                        className="col-12"
                                        style={{ padding: '0px' }}
                                    />
                                </>
                            ) : null}
                        </>
                    )}
                </ParameterArea>
            </div>
        );
    }

    function renderPluginTest() {
        switch (p_type) {
            case 'dynamic_answers':
                return renderDynamicAnswerTest();
            default:
                return null;
        }
    }

    return (
        <Dialog open onClose={handleFormClose} maxWidth="md" fullWidth>
            <CustomDialogTitle
                title={
                    <>
                        <LocaleMessage msg="page.plugins.form.test_config.title" />
                        {pluginConfig && pluginConfig.name
                            ? ` [${pluginConfig.name}]`
                            : ''}
                    </>
                }
            />
            <DialogContent>{renderPluginTest()}</DialogContent>
            <DialogActions>
                <Button
                    onClick={event => handleFormClose(event)}
                    color="primary"
                >
                    <LocaleMessage msg="button.close" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

PluginconfigTest.propTypes = {
    handleFormClose: PropTypes.func.isRequired,
    pluginType: PropTypes.object.isRequired,
    pluginConfig: PropTypes.object.isRequired,
};
